import { useState, useEffect } from "react";
import { useDebounceHook } from "../utils/useDebounceHook";

//
export default function InputSearch({
  value,
  onChange,
  placeholder,
  style,
  customClassName,
}) {
  const [searchValue, setSearchValue] = useState(value);
  const debouncedSearchValue = useDebounceHook(searchValue, 500);

  // sync internal state when value is cleared externally (e.g. ResetFilterButton)
  useEffect(() => {
    if (value === "" || value === undefined) {
      setSearchValue("");
    }
  }, [value]);

  useEffect(() => {
    debouncedSearchValue !== value && onChange(debouncedSearchValue);
  }, [debouncedSearchValue, onChange]);

  const classNames = `form-control ${customClassName || ""}`;

  return (
    <input
      type="text"
      className={classNames}
      placeholder={placeholder || "Iskanje..."}
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      style={style}
    />
  );
}
